import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import userexchange from "./home_assets/user_guide.svg";
import ex1 from "./home_assets/user_ex1.svg";
import ex2 from "./home_assets/user_ex2.svg";
import explay from "../../assets/images/homepage/googlePlayICon.png";
import apple from "../../assets/images/homepage/AppICon.png";
import test from "../../assets/images/homepage/testflightIcon.png";
import android from "../../assets/images/homepage/androidICon.png";
import QrCode from "../qrCode/qrCode";

import "./home_styles/homeexchange.css";

export default function HomeExchange() {
  return (
    <>
      <Container className="mt-5 pb-5">
        <Row>
          <Col>
            <div className="user_exchange_upper">
              <div className="global_upper_img text-center">
                <img src={userexchange} alt="Userexchange" />
              </div>
              <div className="exchange_upper_head d-flex flex-column align-items-center">
                <h1>A SECURE AND EASY TO USE EXCHANGE</h1>
                <span>
                  Borderless, community decentralization and autonomy, team
                  decentralize is the ultimate form of SuperEx development.
                </span>
              </div>
            </div>
            <Row className="mt-5 mb-5">
              <Col lg={6}>
                <div className="exchange_left_imgs">
                  <div className="ex_fst_img">
                    <img src={ex1} alt="" className="img-flui fst_img" />
                  </div>
                  <div className="ex_scnd_img">
                    <img src={ex2} alt="" className="scnd_img" />
                  </div>
                </div>
              </Col>
              <Col lg={6}>
                <div className="exchange_right_col d-flex flex-column gap-4">
                  <div className="ex_right_up d-flex justify-content-evenly text-end py-lg-0 py-md-4 py-4">
                    <div className="ex_right_up_fst text-center">
                      <img src={apple} alt="" className="img-fluid" />
                    </div>
                    <div className="ex_right_up_scnd">
                      <img src={test} alt="" className="img-fluid" />
                    </div>
                  </div>
                  <div className="ex_right_down d-flex justify-content-evenly py-lg-0 py-md-4 py-4">
                    <div className="ex_right_down_fst">
                      <img src={explay} alt="" className="img-fluid" />
                    </div>
                    <div className="ex_right_down_scnd">
                      <img src={android} alt="" className="img-fluid" />
                    </div>
                  </div>
                  <div className="mt-2 text-center rounded home_ex_qr">
                    <QrCode sizeOfQR={170} value={"https://www.youtube.com/"} />
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
}
